export interface TeacherContract {
  id: number;
  is_active: boolean;
  groups: string[];
  kindergarten_ids?: number[];
}
